import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  LinearProgress,
  Grid,
  Button,
} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import './FileUploadInProgress.sass';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {ReducerState} from 'rootReducer';
import {useDispatch, useSelector} from 'react-redux';
import {isLoaded, toEither} from 'Core/models/Async';
import {
  changeFileUploadCancelTokens,
  getEnrollmentApplications,
  getFilesInUploadProgress,
} from 'Enrollment/ducks/enrollmentFileProcessing';
import {pipe} from 'fp-ts/lib/pipeable';
import {fold as foldEither} from 'fp-ts/lib/Either';
import DescriptionIcon from '@material-ui/icons/Description';
import {FileUploadCancelTokenDetail} from 'Enrollment/models/FileUploadCancelTokenDetail';
import {createSnackbar} from 'Core/ducks/snackbar';

const disableCancelButton = (fileUploadCancelTokens: FileUploadCancelTokenDetail[], id: string): boolean => {
  const fileUploadCancelToken = fileUploadCancelTokens.find(x => x.fileId === id);
  return fileUploadCancelToken ? fileUploadCancelToken.isCancel : true;
};

const FileUploadsInProgress = () => {
  const {fileUploadsInProgress, enrollmentApplicationsFilters, fileUploadCancelTokens} = useSelector(
    (state: ReducerState) => state.enrollmentFileProcessing
  );
  const [intervalId, setIntervalId] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFilesInUploadProgress());
  }, []);

  useEffect(() => {
    clearInterval(intervalId);
    const interval = setInterval(() => {
      if (isLoaded(fileUploadsInProgress)) {
        if (fileUploadsInProgress.Data.length > 0) {
          dispatch(getFilesInUploadProgress());
        }
      }
    }, 15000);
    setIntervalId(interval);
    if (isLoaded(fileUploadsInProgress) && fileUploadsInProgress.Data.length === 0) {
      dispatch(getEnrollmentApplications(undefined, enrollmentApplicationsFilters));
      clearInterval(intervalId);
    }
    return () => clearInterval(interval);
  }, [fileUploadsInProgress]);

  return pipe(
    fileUploadsInProgress,
    toEither,
    foldEither(
      () => <></>,
      files =>
        files.length > 0 ? (
          <div className="file-upload-in-progress">
            <Accordion className="accordion">
              <AccordionSummary
                className="file-upload-in-progress__accordion-summary"
                expandIcon={<ExpandMoreIcon className="file-upload-in-progress__accordion-summary--expand-icon" />}
                aria-controls="file-upload-in-progress-content"
                id="file-upload-in-progress-header"
              >
                <Typography className="file-upload-in-progress__accordion-summary--title">Uploading</Typography>
                <span className="file-upload-in-progress__accordion-summary--vlaue">{files.length} item(s)</span>
              </AccordionSummary>
              <AccordionDetails className="file-upload-in-progress__details">
                {files.map((file, index) => (
                  <Grid
                    key={index}
                    container
                    spacing={2}
                    wrap="nowrap"
                    className="file-upload-in-progress__details--item"
                  >
                    <Grid key={index} item xs={1}>
                      <DescriptionIcon className="file-icon" />
                    </Grid>
                    <Grid item zeroMinWidth xs={7}>
                      <div className="file-name">{file.fileName}</div>
                    </Grid>
                    <Grid item xs={2}>
                      <LinearProgress />
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        disabled={disableCancelButton(fileUploadCancelTokens, file.id!)}
                        onClick={() => {
                          const fileUploadCancelDetail = fileUploadCancelTokens.find(x => x.fileId === file.id);
                          if (fileUploadCancelDetail && fileUploadCancelDetail.cancelTokenSource) {
                            fileUploadCancelDetail.cancelTokenSource.cancel('Cancelled By User');
                            fileUploadCancelDetail.isCancel = true;
                            dispatch(changeFileUploadCancelTokens(fileUploadCancelTokens));
                            dispatch(createSnackbar(`Cancelling ${file.fileName}`));
                          }
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </AccordionDetails>
            </Accordion>
          </div>
        ) : null
    )
  );
};

export default FileUploadsInProgress;
